import styled from 'styled-components';

import Text from './Text';

const Label = styled(Text)`
  font-weight: bold;
`;

export default Label;
